import React, { useRef, useEffect } from "react";

export const AutoResizeTextarea = ({ name, value, placeholder, onChange, className, disabled }) => {
    const textareaRef = useRef(null);

    const adjustTextareaHeight = () => {
        const textarea = textareaRef.current;
        if (textarea) {
            textarea.style.height = "auto";
            // 스크롤 높이에 맞춰 높이 조정
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    };

    useEffect(() => {
        adjustTextareaHeight();
    }, [value]);

    return (
        <textarea
            ref={textareaRef}
            name={name}
            placeholder={placeholder}
            value={value || ""}
            onChange={onChange}
            disabled={disabled}
            className={className}
            style={{
                minHeight: "36px",
                resize: "none",
                overflow: "hidden",
                width: "100%",
            }}
        />
    );
};
